import { Component, Vue, Prop } from 'vue-property-decorator'
import { ImagePreview } from 'vant';
@Component
export default class CommonVue extends Vue {
    //点击判断是否有图片，有的话，就进行预览
    showImg(e:any) {
        if (e.target.tagName == 'IMG') {
          // @ts-ignore
          e.stopPropagation();
          ImagePreview([e.target.src]);
        }
    }
}